module.exports = __webpack_public_path__ + "img/city-background.c4afd22a.png";